module.exports = __webpack_public_path__ + "static/media/User-card.d30274f2.png";